import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  SupplierNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Supplier as SupplierEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import SupplierModel from "../../data/model/Supplier";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const suppliersQuery = gql`
${SupplierNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetSuppliers(${listVariables}) {
    suppliers(${listOptions}) {
        items {
          ...SupplierNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const supplierDefinition = new EntityResourceDefinition<
  SupplierEntity,
  SupplierModel
>({
  entity: "suppliers",
  query: suppliersQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity?.name || "";
    newEntity.suppCode = fetchedEntity.suppCode;
    newEntity.active = fetchedEntity.active;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "suppliers", suppliersQuery, options);
  },
});
